export default __webpack_public_path__ + "static/media/gamepad.98eab601.svg";